module.exports = __webpack_public_path__ + "static/koko-0517c8571f87e9ef50f963055727fef8.jpg";